import { applyCartResponse } from '../../home-page/business-logic/common/apply-cart-response';
import { popupMessage } from '../../messages/business-logic/popup-message';
import { voidAllCoupons, voidCoupon } from './service/coupon-services';

export const voidCouponLineItem = async (linkedItem: number): Promise<void> => {
  return voidCoupon(linkedItem).then(applyCartResponse);
};

export const voidAllCouponsButtonAction = async (): Promise<void> => {
  return voidAllCoupons()
    .then(applyCartResponse)
    .catch(popupMessage);
};
